module.exports = __webpack_public_path__ + "static/media/Avatar6b.f8c08c65.png";